export const DEFAULT_HOST_IMAGE = '/images/jack_ass_medallion.png';
const HOST_IMAGE_DIRECTORY = '/images/hosts';
const SAFE_HOST_IMAGE_FILENAME = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;

export function getHostImageSrc(imageFilename) {
  if (typeof imageFilename !== 'string') {
    return DEFAULT_HOST_IMAGE;
  }

  const trimmedFilename = imageFilename.trim();
  if (!trimmedFilename || !SAFE_HOST_IMAGE_FILENAME.test(trimmedFilename)) {
    return DEFAULT_HOST_IMAGE;
  }

  return `${HOST_IMAGE_DIRECTORY}/${trimmedFilename}`;
}

export default getHostImageSrc;
